import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  ModalWrapper,
  Header,
  Content,
  Actions,
  ModalBackDropWrapper,
  headerIdentityStyle,
  ExitButton,
  WarningIcon,
} from './Modal.styles';
import { Button } from "@hiver/hiver-ui-kit";

export const IntegrationModal = function ({
  title,
  message,
  leftButtonProps,
  rightButtonProps,
  className,
  onClickLeft,
  onClickRight,
  isOpen,
  parentContainer,
  modalStyle,
  footerStyle,
  exitIcon,
  modalType,
}) {
  const openModal = isOpen ? "modal-open" : "";
  const target = parentContainer ? parentContainer : document.body;
  const headerStyle = headerIdentityStyle;

  return ReactDOM.createPortal(
    <ModalBackDropWrapper isOpen={isOpen} className={openModal}>
      <ModalWrapper isOpen={isOpen} style={modalStyle} className={className}>
        {exitIcon && (
          <ExitButton src={exitIcon} onClick={onClickLeft} />
        )}
        <Header style={headerStyle}>
          {modalType && <WarningIcon src={modalType} />} {/*Type of message: Warning*/}
          {title}
        </Header>
        <Content className="modal-content">{message}</Content>
        {(leftButtonProps || rightButtonProps) && (
          <Actions style={footerStyle}>
            {leftButtonProps && (
              <Button 
                className="cancel-button"
                onClick={onClickLeft}
                color="tertiary"
                size="medium"
                variant="outlined">
                {leftButtonProps.value}
              </Button>
            )}
            {rightButtonProps && (
              <Button 
                className="action-button"
                onClick={onClickRight}
                color="error" 
                size="medium"
                variant="contained">
                {rightButtonProps.value}
              </Button>
            )}
          </Actions>
        )}
      </ModalWrapper>
    </ModalBackDropWrapper>,
    target
  );
};

IntegrationModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.node,
  isOpen: PropTypes.bool,
  leftButtonProps: PropTypes.object,
  rightButtonProps: PropTypes.object,
  onClickLeft: PropTypes.func,
  onClickRight: PropTypes.func,
  modalStyle: PropTypes.object,
  footerStyle: PropTypes.object,
  exitIcon: PropTypes.node,
  modalType: PropTypes.node,
};

IntegrationModal.defaultProps = {
  title: "",
  message: "",
  isOpen: false,
  leftButtonProps: {},
  rightButtonProps: {},
  onClickLeft: () => {
    /* This is intentional*/
  },
  onClickRight: () => {
    /* This is intentional*/
  },
  exitIcon: "",
  modalType: "",
};
